module.exports = __webpack_public_path__ + "img/trubadur.7c720013.jpg";